import React from 'react';

import './styles.scss';

const NotFound: React.FC = () => {
  return <div className="not-found">404: Not Found</div>;
};

export default NotFound;
